import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { RichTextAccordionBlockNode } from '@cinemark/content-api-client';
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical';
import { RichTextRenderer } from '../rich-text-renderer';

type RichTextAccordionBlockComponentProps = {
  node: SerializedBlockNode | undefined;
};

export const RichTextAccordionBlockComponent = ({ node }: RichTextAccordionBlockComponentProps): React.JSX.Element | null => {
  if (!node || node.type !== 'block' || !node.fields || typeof node.fields !== 'object' || node.fields.blockType !== 'accordion') return null;

  const fields = node.fields as unknown as RichTextAccordionBlockNode;

  return (
    <Accordion collapsible
      className="shadow-sm p-ms mt-sm first:mt-0"
      defaultValue={fields.defaultExpanded ? fields.id : undefined}
      type="single"
    >
      <AccordionItem value={fields.id}>
        <AccordionTrigger className="text-base">{fields.title}</AccordionTrigger>
        <AccordionContent className="pb-0">
          <RichTextRenderer content={fields.content} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
